import { cn } from "@somethings-ui/core";
import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ToolRowProps {
  thumbnail: ReactNode;
  title: string;
  subtitle?: string;
  disabled?: boolean;
  tooltip?: string;
  onClick?: () => void;
}

export function ToolRow({
  thumbnail,
  title,
  subtitle,
  disabled,
  tooltip,
  onClick,
}: ToolRowProps) {
  const row = (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex w-full items-center gap-3 rounded-[16px] p-2 text-left transition-colors",
        disabled ? "cursor-not-allowed opacity-50" : "hover:bg-surfaces-z0",
      )}
    >
      {thumbnail}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-body text-body-2 text-text-primary">
          {title}
        </span>
        {subtitle ? (
          <span className="truncate font-body text-body-3 text-text-tertiary">
            {subtitle}
          </span>
        ) : null}
      </div>
      <ChevronRight className="size-4 shrink-0 text-text-tertiary" />
    </button>
  );

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="w-full">{row}</div>
        </TooltipTrigger>
        <TooltipContent side="left" className="max-w-xs">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    );
  }

  return row;
}
